import { MAX_SUBJECT_LENGTH } from './../constants/email';
export const parseEmailSubjectLength = (emailSubject: string) => {
  if (emailSubject.length > MAX_SUBJECT_LENGTH) {
    return emailSubject.substring(0, MAX_SUBJECT_LENGTH - 1).concat('…');
  }
  return emailSubject;
};
